import type { TourStep } from '@/types/help-tour';
import { buildTourSteps, type TourStepDef } from '@/utils/tourI18n';

const STEP_DEFS: TourStepDef[] = [
  { target: '[data-tour="sources-intro"]' },
  { target: '[data-tour="sources-controls"]' },
  { target: '[data-tour="sources-add"]' },
  { target: '[data-tour="sources-list"]' }
];

export const FAMILY_SOURCES_TOUR_STEPS: TourStep[] = buildTourSteps('familySources', STEP_DEFS);

export const FAMILY_SOURCES_TOUR_STORAGE_KEY = 'wetree-family-sources-tour-completed';

export function resolveFamilySourcesTourSteps(steps: TourStep[], hasSources: boolean, canEdit = true): TourStep[] {
  return steps.filter((step) => {
    if (!hasSources && step.target === '[data-tour="sources-list"]') return false;
    if (!hasSources && step.target === '[data-tour="sources-controls"]') return false;
    if (!canEdit && step.target === '[data-tour="sources-add"]') return false;
    return true;
  });
}
